import { Typography } from "@mui/material";
import React from "react";
import { StyledCalendarLabel } from "../../../../styled/calendar";

const CalendarLabel = () => {
  return (
    <StyledCalendarLabel.Container elevation={2}>
      <StyledCalendarLabel.Label>
        <StyledCalendarLabel.Icon stateColor="red" />
        <Typography variant="caption">No Informados</Typography>
      </StyledCalendarLabel.Label>
      <StyledCalendarLabel.Label>
        <StyledCalendarLabel.Icon stateColor="black" />
        <Typography variant="caption">Ausentes</Typography>
      </StyledCalendarLabel.Label>
      <StyledCalendarLabel.Label>
        <StyledCalendarLabel.Icon stateColor="blue" />
        <Typography variant="caption">Presentes</Typography>
      </StyledCalendarLabel.Label>
      <StyledCalendarLabel.Label>
        <StyledCalendarLabel.Icon stateColor="green" />
        <Typography variant="caption">Programados</Typography>
      </StyledCalendarLabel.Label>
      <StyledCalendarLabel.Label>
        <StyledCalendarLabel.Icon stateColor="grey" />
        <Typography variant="caption">Anulados</Typography>
      </StyledCalendarLabel.Label>
    </StyledCalendarLabel.Container>
  );
};

export default CalendarLabel;
